export default "__VITE_ASSET__BXykEbrT__"